'use client'

import { useState } from 'react'
import { t } from '@lingui/core/macro'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { PatientLocationData } from '../lib/patient-location.types'
import { PatientLocationModal } from './PatientLocationModal'

type PatientLocationControlProps = {
  consultationId: string
  initialLocation?: PatientLocationData | null
}

export function PatientLocationControl({ consultationId, initialLocation }: PatientLocationControlProps) {
  const [isOpen, setIsOpen] = useState(!initialLocation)

  return (
    <>
      <Tooltip title={t`Patient location`}>
        <IconButton
          aria-label={t`Patient location`}
          onClick={() => setIsOpen(true)}
          sx={{
            color: 'white',
            bgcolor: 'rgba(255,255,255,0.1)',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
          }}
        >
          <LocationOnOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <PatientLocationModal open={isOpen} onClose={() => setIsOpen(false)} consultationId={consultationId} initialLocation={initialLocation ?? null} />
    </>
  )
}
